import type { PaidResourceListItem } from "@/lib/api/paid-access";

export function paidResourceStateLabel(state: PaidResourceListItem["derivedState"]) {
  switch (state) {
    case "active":
      return "Active";
    case "expired":
      return "Expired";
    case "revoked":
      return "Revoked";
    default:
      return "Not purchased";
  }
}

export function paidResourceStateBadgeClass(state: PaidResourceListItem["derivedState"]) {
  switch (state) {
    case "active":
      return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case "expired":
      return "bg-amber-100 text-amber-800 border-amber-200";
    case "revoked":
      return "bg-red-100 text-red-800 border-red-200";
    default:
      return "bg-slate-100 text-slate-700 border-slate-200";
  }
}
